/** Outils de manipulation dans le plan orbital. */
export type SandboxTool = "select" | "planet" | "star" | "move" | "velocity";
export interface WorldPoint { readonly x: number; readonly y: number }
/** Une flèche d’une unité astronomique représente 30 km/s. */
export const VELOCITY_PER_METRE = 30000 / 1.496e11;
export function launchVelocity(start: WorldPoint, end: WorldPoint): WorldPoint {
  const vx = (end.x - start.x) * VELOCITY_PER_METRE;
  const vy = (end.y - start.y) * VELOCITY_PER_METRE;
  const factor = Math.min(1, 1e6 / Math.max(Math.hypot(vx, vy), 1));
  return { x: vx * factor, y: vy * factor };
}
